"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const queryParse_1 = __importDefault(require("./queryParse"));
const queryBuild_1 = __importDefault(require("./queryBuild"));
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const uniq_1 = __importDefault(require("lodash/uniq"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const isObject_1 = __importDefault(require("lodash/isObject"));
const queryAppendParam = (query, paramName, paramValue) => {
    var _a;
    const newQuery = (0, isObject_1.default)(query) ? Object.assign({}, query) : (0, queryParse_1.default)(query);
    const existingValue = (_a = newQuery[paramName]) !== null && _a !== void 0 ? _a : null;
    if (paramName in newQuery && ((0, isObject_1.default)(existingValue) || (0, isArray_1.default)(existingValue))) {
        let newExistingValue;
        if ((0, isPlainObject_1.default)(paramValue)) {
            newExistingValue = Object.assign(Object.assign({}, newQuery[paramName]), paramValue);
        }
        else if ((0, isArray_1.default)(paramValue)) {
            newExistingValue = (0, uniq_1.default)([...newQuery[paramName], ...paramValue]);
        }
        else {
            newExistingValue = Object.assign(Object.assign({}, newQuery[paramName]), { paramValue });
        }
        newQuery[paramName] = newExistingValue;
    }
    else {
        newQuery[paramName] = paramValue;
    }
    return ((0, isObject_1.default)(query) ? newQuery : (0, queryBuild_1.default)(newQuery));
};
exports.default = queryAppendParam;
